/**
 * Default filter/dialog options served immediately (and as a resilient
 * fallback if the constants query fails), then refined from the API in
 * useTradeinConstants. Not test data — these keep filters and dialogs usable
 * before/without a successful constants fetch.
 */
import type { TradeinConstants } from './types';

export const DEFAULT_TRADEIN_STATES: TradeinConstants['states'] = [
  { code: 'CREATED', displayName: 'Created' },
  { code: 'PENDING', displayName: 'Pending' },
  { code: 'TRADEIN_INBOUND', displayName: 'Trade-in Inbound' },
  { code: 'TRADEIN_ARRIVED', displayName: 'Trade-in Arrived' },
  { code: 'TRADEIN_PROCESSING', displayName: 'Trade-in Processing' },
  { code: 'TRADEIN_REVIEW', displayName: 'Trade-in Review' },
  { code: 'TRADEIN_PROCESSED', displayName: 'Trade-in Processed' },
  { code: 'TRADEIN_COMPLETED', displayName: 'Trade-in Completed' },
  { code: 'INSTI_PROCESSING', displayName: 'INSTI Processing' },
  { code: 'INSTI_COMPLETED', displayName: 'INSTI Completed' },
  { code: 'CANCELED', displayName: 'Canceled' },
];
export const DEFAULT_TRADEIN_SOURCES: TradeinConstants['sources'] = [
  { code: 'MITI', displayName: 'Digital Trade-in (DITI)' },
  { code: 'INSTI', displayName: 'In-store (INSTI)' },
];
export const DEFAULT_SENDBACK_STATES: TradeinConstants['sendbackStates'] = [
  { code: 'REQUESTED', displayName: 'Requested' },
  { code: 'PACKING', displayName: 'Packing' },
  { code: 'PACKED', displayName: 'Packed' },
  { code: 'SHIPPED', displayName: 'Shipped' },
  { code: 'DELIVERED', displayName: 'Delivered' },
  { code: 'FLAGGED', displayName: 'Flagged' },
];
export const DEFAULT_CONDITIONS: TradeinConstants['conditions'] = [
  { code: 'GRADE_A', displayName: 'Like New' },
  { code: 'GRADE_B', displayName: 'Excellent' },
  { code: 'GRADE_C', displayName: 'Good' },
  { code: 'GRADE_D', displayName: 'Fair' },
];
export const DEFAULT_REJECT_REASONS: TradeinConstants['rejectReasons'] = [
  { code: 'BETTER_PRICE', displayName: 'Seller is shopping around for a better price' },
  { code: 'PRICE_TOO_LOW', displayName: 'Seller thinks offer is too low' },
  { code: 'CHANGED_MIND', displayName: 'Seller changed their mind' },
  { code: 'DUPLICATE', displayName: 'Duplicate item or other mistake' },
  { code: 'OTHER', displayName: 'Other' },
];
export const DEFAULT_GIFTCARD_REASONS: TradeinConstants['giftcardReasons'] = [
  { code: 'SHIPPING_ISSUE', displayName: 'Shipping Issue' },
  { code: 'CS_ISSUE', displayName: 'Customer Service Issue' },
  { code: 'PROMOTIONS', displayName: 'Promotions' },
  { code: 'OTHER', displayName: 'Other' },
];
